module.exports = __webpack_public_path__ + "img/long-arrow-orange.b4e47c96.svg";